import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { Redirect, Link } from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { injectIntl } from 'react-intl';
// import Modal from '../../components/Modal/modal';
// import FaceRecognition from '../../components/FacialRecognition/Recognition';
import {
  login,
  saveCredentials,
  clearAutoLogout,
} from '../../redux/actions/member';
import logoLoginPng from '../../assets/img/logo-login.png';
import { nonBrowserFeatureState } from '../../utils/non-browser-state';

import styles from '../../jss/views/loginStyle';
import FormHeader from '../../components/AuthFormHeader';
// import usePrevious from '../../hooks/usePrevious';

const messages = {
  login: {
    id: 'app.login.login',
    defaultMessage: 'Login',
  },
};

const useStyles = makeStyles(styles);

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Login = (props) => {
  const classes = useStyles();
  const {
    dispatch,
    member,
    intl: { formatMessage },
  } = props;
  const loginAttempt = member.loginAttempt;
  const propsLoginErr = member.loginErr;
  const credentials = member.credentials;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailErr, setEmailErr] = useState(false);
  const [pwdErr, setPwdErr] = useState(false);
  const [loginErr, setLoginErr] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  // const [showRecognition, setShowRecognition] = useState(false);
  const emailRef = React.useRef();
  const passwordRef = React.useRef();

  // const previousSessionId = usePrevious(member.session_id);

  const handleEmailChange = (evt) => {
    setEmail(evt.target.value);
    setEmailErr(false);
    setLoginErr(false);
  };
  const handlePasswordChange = (evt) => {
    setPassword(evt.target.value);
    setPwdErr(false);
    setLoginErr(false);
  };
  const handlePasswordKeyChange = (evt) => {
    if (evt.key === 'Enter') {
      onLogin();
    }
  };
  const handleEmailKeyChange = (evt) => {
    if (evt.key === 'Enter') {
      passwordRef.current.focus();
    }
  };
  const onLogin = async () => {
    const formData = { username: email, password };

    if (!!!formData.username) {
      setEmailErr(true);
      return;
    }

    if (!!!password) {
      setPwdErr(true);
      return;
    }
    if (rememberMe) dispatch(saveCredentials({ email }));
    dispatch(login(JSON.stringify(formData)));
  };

  useEffect(() => {
    emailRef && emailRef.current && emailRef.current.focus();
  }, [emailRef]);

  useEffect(() => {
    console.debug('propsLoginErr', propsLoginErr);
    console.debug('loginAttempt', loginAttempt);
    setLoginErr(true);
  }, [propsLoginErr, loginAttempt]);

  useEffect(() => {
    if (credentials && credentials.email !== undefined)
      setEmail(credentials.email);
  }, [credentials]);

  // useEffect(() => {
  //   console.log('member.session_id', member.session_id);
  //   // setShowRecognition(true);
  // }, [member.session_id]);

  // That will let the data to load properly before we display the app
  const now = new Date();
  const end = member.member ? new Date(member.member.expiration_date) : now;
  if (
    member.session_id &&
    member.member &&
    member.memberInfo &&
    member.memberInfo.email &&
    now < end
    // &&
    // ((member.memberInfo.facial_recognition && member.faceMatched) ||
    //   !member.memberInfo.facial_recognition)
  ) {
    console.log('Firing redirection after login()');
    console.log('memberInfo', member.memberInfo);
    console.log('memberfaceMatched', member.faceMatched);
    return <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />;
  }

  const handleClose = () => {
    dispatch(clearAutoLogout());
  };

  // const ModalContent = () => {
  //   return <FaceRecognition />;
  // };

  // const ModalAction = () => {
  //   return (
  //     <Button
  //       variant="contained"
  //       color="secondary"
  //       disableRipple
  //       onClick={() => {
  //         setShowRecognition(false);
  //       }}
  //     >
  //       Close
  //     </Button>
  //   );
  // };

  return (
    <div className={classes.loginPage}>
      <FormHeader />
      <div className={classes.formSection}>
        {!nonBrowserFeatureState && (
          <div className={classes.goHome}>
            <Link to={`${process.env.PUBLIC_URL}/home`}>&lt;- Home</Link>
          </div>
        )}
        <div className={classes.logoImg}>
          <img src={logoLoginPng} alt="logo" />
        </div>
        <div className="emailInput">
          <TextField
            error={emailErr}
            inputRef={emailRef}
            helperText={emailErr && 'Invalid Username!'}
            label="Email Address or Username"
            fullWidth
            color="primary"
            value={email}
            onChange={handleEmailChange}
            onKeyDown={handleEmailKeyChange}
          />
        </div>
        <div className={classes.passwordInput}>
          <TextField
            inputRef={passwordRef}
            error={pwdErr}
            helperText={pwdErr && "Password can't be blank!"}
            label="Password"
            color="primary"
            type="password"
            fullWidth
            value={password}
            onChange={handlePasswordChange}
            onKeyDown={handlePasswordKeyChange}
          />
        </div>
        <Grid container spacing={3}>
          <Grid container item xs={11} sm={6} md={6} lg={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={() => {
                    setRememberMe((value) => !value);
                  }}
                  name="rememberMe"
                  color="primary"
                />
              }
              label="Remember me"
            />
          </Grid>
          <Grid
            container
            item
            justify="flex-end"
            xs={11}
            sm={6}
            md={6}
            lg={6}
            className={classes.forgotPasswordLabel}
          >
            <label>
              <Link to={`${process.env.PUBLIC_URL}/login/forgot`}>
                Forgot Password?
              </Link>
            </label>
          </Grid>
        </Grid>
        {loginErr && <div>{propsLoginErr}</div>}
        <div className={classes.loginWrapper}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onLogin}
          >
            {formatMessage(messages.login)}
          </Button>
          {/* <label>Don’t have an account? <Link to={`${process.env.PUBLIC_URL}/signup`}>Sign Up</Link></label> */}
        </div>
      </div>
      <Snackbar
        open={member.autoLogout}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} onClick={handleClose} severity="warning">
          Your session has timed out, please sign in again
        </Alert>
      </Snackbar>
      {/* {member &&
        member.memberInfo &&
        member.memberInfo.email &&
        member.memberInfo.facial_recognition &&
        !member.faceMatched && (
          <Modal
            open={showRecognition}
            title="Facial Recognition"
            maxWidth="lg"
            disableBackdropClick={true}
            fullWidth={true}
            ModalContent={ModalContent}
            ModalAction={ModalAction}
            onClose={() => {
              setShowRecognition(false);
            }}
          />
        )} */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  member: state.member,
});

export default injectIntl(connect(mapStateToProps)(Login));
